import { themeColorSet, ThemedText, ThemedView } from "@app/theme";
import Right from '../../../assets/Icons/Right'
import Stepper from '../../../assets/Icons/StepperInProgress'
import { WarningCircle } from "../Icons/Icons";
const CompletedIcon = ()=>(
    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
        <ThemedView backgroundColor="bg-surface-primary" width={24} height={24} borderRadius="full" justifyContent="center" alignItems="center">
        <Right size={16} color="#2D57D9"/>
        </ThemedView>
    </ThemedView>
)

const FailedIcon =({highLightText})=>(
    <ThemedView backgroundColor={highLightText ? "bg-fill-error":"text-placeholder"} width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
        <WarningCircle  size={28} weight="fill" color={highLightText ? themeColorSet["icon-error"]:themeColorSet["bg-action-disabled"] }/>
    </ThemedView>
)
const ActionStepper = ({data,showBottomLeftLine}) =>{
    const {status,verticalDisplayName,verticalDescription,highLightText} = data;
    console.log('ActionStepper',data)
    return(
        <ThemedView flexDirection="row" alignItems="center" mb="lg">
        <ThemedView>
            {status === 'COMPLETED' ? <CompletedIcon/> : status === 'FAILED' ? <FailedIcon highLightText={highLightText}/> : <Stepper/>}
        </ThemedView>
        <ThemedView ml='sm' flex={1}>
                <ThemedText variant='b3s' color={highLightText ? 'text-primary' :'text-disabled'}>{verticalDisplayName}</ThemedText>
                <ThemedText variant='b4r' color={highLightText ? 'text-primary' :'text-secondary'}>{verticalDescription}</ThemedText>  
        </ThemedView>
        {showBottomLeftLine && <ThemedView position='absolute' left={15} top={15} zIndex={-1} height={75} width={1} backgroundColor={status === 'COMPLETED' ? 'bg-action-primary' :'border-secondary'} />}
        </ThemedView>
    )
}

export default ActionStepper;
// usage is data.map((item, index) => <ActionStepper data={item} showBottomLeftLine={index.length<data.length-1}/>)